export class ApplicationMessage {
  text: string;
  type: string;
  count: number;

  constructor(t: string, c: string) {
    this.text = t;
    this.type = c;
    this.count = 1;
  }
}
